module.exports = __webpack_public_path__ + "static/media/sol-i-pluja@2x.fa7dd264.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sol-i-pluja@2x.png
// module id = 113
// module chunks = 0